import { render, staticRenderFns } from "./MatrixDesktop.vue?vue&type=template&id=4ed5e0fe&"
import script from "./MatrixDesktop.vue?vue&type=script&lang=js&"
export * from "./MatrixDesktop.vue?vue&type=script&lang=js&"
import style0 from "./MatrixDesktop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VItem,VItemGroup,VSimpleTable})
